import { Box } from '@mui/material';
import DataCard from 'components/data-card/data-card.component';
import {
  useSearchParamsContext,
  useSearchQueryContext,
} from 'components/search/search.hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

const AccountVerificationContent = () => {
  const { t } = useTranslation();

  const {
    searchResults,
    queryState: { isFetching },
  } = useSearchQueryContext();

  const { searchParams: sp, setParamValue } = useSearchParamsContext();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.size) {
      setParamValue('startDate', sp.startDate.value);
      setParamValue('endDate', sp.endDate.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      display="grid"
      gridTemplateColumns={{ xs: 'repeat(1, 1fr)', lg: 'repeat(3, 1fr)' }}
      gap={2}
      data-testid="AccountVerification.Content"
    >
      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.accountVerification.content.smsSent',
        )}
        value={searchResults?.[0]?.smsSent ?? 0}
        valueType="number"
        loading={isFetching}
        data-testid="AccountVerificationSMSSent.Card"
      />

      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.accountVerification.content.smsDelivered',
        )}
        value={searchResults?.[0]?.smsDelivered ?? 0}
        valueType="number"
        loading={isFetching}
        data-testid="AccountVerificationSMSDelivered.Card"
      />

      <DataCard
        title={t(
          'page.reportAndAnalytics.smsReports.sections.accountVerification.content.percentDelivered',
        )}
        value={searchResults?.[0]?.percentDelivered ?? 0}
        valueType="percent"
        loading={isFetching}
        data-testid="AccountVerificationPercentDelivered.Card"
      />
    </Box>
  );
};

export default AccountVerificationContent;
